import styled from "styled-components";

import { ProfileNavigationStyledProps as Props } from "./ProfileNavigation.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { tablet } = BREAKPOINTS;

const ProfileNavigationStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;
  height: max-content;
  border-radius: 1rem;
  background: var(--palette-white);
  overflow: hidden;
  box-shadow: 0px 4px 4px var(--palette-gray-s0-l20-a04),
    0px 4px 16px var(--palette-gray-s0-l20-a08);

  @media (max-width: ${tablet}px) {
    border-radius: 1.6rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .ProfileNavigation {
    &__login-button {
      &.Button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2rem;
        background-color: var(--palette-black-s0-l20);
        border: none;

        @media (max-width: ${tablet}px) {
          width: 90%;
          margin: 0 auto;
          margin-bottom: 4rem;
          padding: 1.6rem 0;
          margin-top: 2.4rem;
          border-radius: 12rem;
          justify-content: center;
          background-color: var(--palette-primary);
        }

        :hover {
          box-shadow: none;
          background-color: var(--palette-gray-s0-l35);
          border: none;
        }
      }

      &__left-content {
        display: flex;
        align-items: center;
      }

      &__user-icon {
        width: 2rem;
        height: 2rem;

        @media (max-width: ${tablet}px) {
          width: 1.6rem;
          height: 1.6rem;
        }

        path {
          fill: var(--palette-white);
        }
      }

      &__text {
        margin-left: 1.2rem;
        font-size: 1.6rem;
        font-weight: 800;
      }

      &__right-content {
        margin: 0;

        @media (max-width: ${tablet}px) {
          display: none;
        }

        path {
          fill: var(--palette-white);
        }
      }
    }

    &__tab {
      display: flex;
      align-items: center;
      padding: 1.6rem 1.8rem;
      text-decoration: none;

      &.is-currently-active {
        position: relative;

        .ProfileNavigation__tab-name {
          font-weight: 600;
          color: var(--palette-gray-s0-l20);
        }

        svg {
          path {
            fill: var(--palette-gray-s0-l20);
          }
        }

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 0.4rem;
          height: 4rem;
          margin: auto 0;
          border-radius: 1.6rem;
          background-color: var(--palette-primary);
        }
      }
    }

    &__tab-icon {
      path {
        fill: var(--palette-gray-s0-l50);
      }
    }

    &__tab-name {
      margin-left: 2.4rem;
      font-size: 1.6rem;
      font-weight: 600;
      color: var(--palette-gray-s0-l50);
    }

    &__badge {
      margin-left: 2rem;
      z-index: 0;

      .Badge__value {
        width: 2rem;
        height: 2rem;
        font-size: 1.5rem;
        top: -1rem;
      }
    }

    &__logout-button {
      display: flex;
      align-items: center;
      padding: 1.6rem 1.8rem;
      text-decoration: none;
      font-family: inherit;
      font-size: 1.6rem;
      font-weight: 600;
      color: var(--palette-gray-s0-l50);
      border: none;
      background: transparent;
      cursor: pointer;

      &__icon {
        margin-right: 2.4rem;
      }
    }
  }
`;

export default ProfileNavigationStyled;
